module.exports = __webpack_public_path__ + "static/bottomBackground-eae1e4d0255fd0263e86f1d463bbabfc.png";